  <div class="blockheader">{{'Main'|translate}}</div>
<div class="datablock">
  <div class="inputgroup">
    <label>{{'Keep history'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [(ngModel)]="Object.DaysToStore" />
      <span>{{'days'|translate}}</span>
    </label>
  </div>
  <div class="inputgroup">
    <label>{{'Max polling time'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [(ngModel)]="timeout" />
      <span>{{'sec'|translate}}</span>
    </label>
  </div>
  <div class="inputgroup" *ngIf="!Object.HasFlag('PERSONAL')">
    <label>{{'Max allowed daily mileage'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [ngModel]="Object.MaxDailyMileage | localizeKMeters" (ngModelChange)="convertMaxDailyMileage($event)" />
      <span>{{'km'|localizeUnits}}</span>
    </label>
  </div>
  <div class="inputgroup" *ngIf="!Object.HasFlag('PERSONAL')">
    <label>{{'Max allowed daily working time'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [ngModel]="Object.MaxDailyEngineTime | localizeHours" (ngModelChange)="convertMaxDailyEngineTime($event)" />
      <span>{{'h' | translate}}</span>
    </label>
  </div>
</div>

<div class="blockheader">{{'Track filtering'|translate}}</div>
<div class="datablock">
  <div class="inputgroup">
    <label>{{'Min. movement speed'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [ngModel]="Object.MinMovingSpeed | localizeSpeed" (ngModelChange)="convertMinMovingSpeed($event)" />
      <span>{{'km/h'|localizeUnits}}</span>
    </label>
  </div>
  <div class="inputgroup">
    <label>{{'Min. satellites count'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [(ngModel)]="Object.MinSatCount" />
    </label>
  </div>
  <div class="inputgroup" *ngIf="!Object.HasFlag('PERSONAL')">
    <label>{{'Measure mileage by'|translate}}</label>
    <select [disabled]="!canEditTrackers" title="{{'Measure distance'|translate}}" (change)="onTypeChange($event)">
      <option value="" [selected]="!Object.HasFlag('MILEAGE_BY_ODO')">{{'GPS'|translate}}</option>
      <option value="MILEAGE_BY_ODO" [selected]="Object.HasFlag('MILEAGE_BY_ODO')">{{'Odometer'|translate}}</option>
    </select>
  </div>
</div>


<div class="blockheader">{{'Parking settings'|translate}}</div>
<div class="datablock">
  <div class="inputgroup">
    <label>{{'Parking radius'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [ngModel]="Object.ParkRadius | localizeMeters" (ngModelChange)="convertParkingRadius($event)" />
      <span>{{'m'|localizeUnits}}</span>
    </label>
  </div>
  <div class="inputgroup">
    <label>{{'Min parking time'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [(ngModel)]="minParkTime" />
      <span>{{'sec'|translate}}</span>
    </label>
  </div>
  <div class="inputgroup" *ngIf="!Object.HasFlag('PERSONAL')">
    <label>{{'Detect parking by ignition'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="checkbox" [checked]="Object.HasFlag('USE_ENGINE_TO_DETECT_PARKINGS')" (change)="onIsParkingDetectedChange($event)" />
    </label>
  </div>
</div>

<div class="blockheader" *ngIf="!Object.HasFlag('PERSONAL')">{{'Fuel'|translate}}</div>
<div class="datablock" *ngIf="!Object.HasFlag('PERSONAL')">
  <div class="inputgroup">
    <label>{{'Min idle time'|translate}}</label>
    <label>
      <input [readonly]="!canEditTrackers" type="number" [(ngModel)]="minIdleTime" />
      <span>{{'sec'|translate}}</span>
    </label>
  </div>
  <div class="inputgroup">
    <label>{{'Fuel consumption per 100'|translate}} {{'km'|localizeUnits}}</label>
    <input [readonly]="!canEditTrackers" type="number" step="any" placeholder="0.00" [(ngModel)]="Object.FuelExpenseKm" />
  </div>
  <div class="inputgroup">
    <label>{{'Hourly fuel consumption'|translate}}</label>
    <input [readonly]="!canEditTrackers" type="number" step="any" placeholder="0.00" [(ngModel)]="Object.FuelExpenseHr" />
  </div>
  <div class="inputgroup">
    <label>{{'Min refueling'|translate}}</label>
    <input type="number" step="any" placeholder="0.00" [(ngModel)]="Object.MinRefueling" />
  </div>
  <div class="inputgroup">
    <label>{{'Min fuel drain'|translate}}</label>
    <input [readonly]="!canEditTrackers" type="number" step="any" placeholder="0.00" [(ngModel)]="Object.MinDrain" />
  </div>
  <div class="inputgroup">
    <label>{{'Min fuel drain speed'|translate}}</label>
    <input [readonly]="!canEditTrackers" type="number" step="any" placeholder="0.00" [(ngModel)]="Object.MinDrainSpeed" />
  </div>
  <div class="inputgroup">
    <label>{{'Ignore fuel drain in motion'|translate}}</label>
    <input [readonly]="!canEditTrackers" type="checkbox" [(ngModel)]="Object.DetectDrainOnParkingOnly" />
  </div>
  <div class="inputgroup">
    <label>{{'Ignore refueling in motion'|translate}}</label>
    <input [readonly]="!canEditTrackers" type="checkbox" [(ngModel)]="Object.DetectRefuelingOnParkingOnly" />
  </div>
</div>
